import { createTheme } from "@mui/material/styles";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    dashed: true;
  }
}

declare module "@mui/material/TextField" {
  interface TextFieldPropsVariantOverrides {
    title: true;
  }
}

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 350,
      md: 768,
      lg: 1024,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: [
      "游ゴシック体",
      "YuGothic",
      "游ゴシック",
      "Yu Gothic",
      "凸版文久見出しゴシック",
      "見出しゴシック",
      "MS ゴシック",
      "MS Gothic",
      "ＭＳ ゴシック",
      "Noto Sans JP",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },

  components: {},

  palette: {
    error: {
      main: "#F44336",
    },

    primary: {
      main: "#2C31A6",
    },
    secondary: {
      main: "#00AD92",
    },
    info: {
      main: "#FC2E14",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
  },
});
